// src/data/industryEnergyVectors.js
const INDUSTRY = {
  net_zero_futures_dvl_shift_high_0909: {
    2025: { electricity: 64.68, hydrogen: 0.62, fossil: 140.40, biofuels: 38.78, other: 0 },
    2030: { electricity: 52.76, hydrogen: 1.69, fossil: 121.99, biofuels: 44.88, other: 0 },
    2035: { electricity: 50.51, hydrogen: 7.36, fossil: 92.48,  biofuels: 59.18, other: 0 },
    2040: { electricity: 45.40, hydrogen: 16.49, fossil: 82.70, biofuels: 56.94, other: 0 },
    2045: { electricity: 50.90, hydrogen: 31.06, fossil: 53.80, biofuels: 63.70, other: 0 },
    2050: { electricity: 57.50, hydrogen: 53.06, fossil: 22.54, biofuels: 62.39, other: 0 },
  },

  net_zero_futures_dvl_shift_low_0909: {
    2025: { electricity: 56.24, hydrogen: 0.62, fossil: 140.40, biofuels: 38.78, other: 0 },
    2030: { electricity: 53.00, hydrogen: 2.32, fossil: 120.78, biofuels: 46.41, other: 0 },
    2035: { electricity: 50.19, hydrogen: 8.38, fossil: 91.91,  biofuels: 61.20, other: 0 },
    2040: { electricity: 45.53, hydrogen: 18.13, fossil: 83.15, biofuels: 55.75, other: 0 },
    2045: { electricity: 47.71, hydrogen: 33.71, fossil: 63.20, biofuels: 50.00, other: 0 },
    2050: { electricity: 56.31, hydrogen: 57.32, fossil: 25.65, biofuels: 52.75, other: 0 },
  },

  net_zero_futures_dvl_steer_high_0909: {
    2025: { electricity: 56.24, hydrogen: 0.62, fossil: 140.40, biofuels: 38.78, other: 0 },
    2030: { electricity: 56.04, hydrogen: 4.19, fossil: 113.09, biofuels: 49.45, other: 0 },
    2035: { electricity: 64.01, hydrogen: 11.38, fossil: 76.06, biofuels: 58.98, other: 0 },
    2040: { electricity: 51.86, hydrogen: 22.25, fossil: 76.54, biofuels: 48.30, other: 0 },
    2045: { electricity: 63.56, hydrogen: 39.74, fossil: 46.26, biofuels: 45.74, other: 0 },
    2050: { electricity: 78.35, hydrogen: 66.68, fossil: 23.73, biofuels: 28.97, other: 0 },
  },

  net_zero_futures_dvl_steer_low_0909: {
    2025: { electricity: 56.24, hydrogen: 0.62, fossil: 140.40, biofuels: 38.78, other: 0 },
    2030: { electricity: 62.72, hydrogen: 4.17, fossil: 104.57, biofuels: 53.02, other: 0 },
    2035: { electricity: 72.96, hydrogen: 11.36, fossil: 63.48, biofuels: 65.20, other: 0 },
    2040: { electricity: 67.00, hydrogen: 22.20, fossil: 53.96, biofuels: 60.46, other: 0 },
    2045: { electricity: 72.81, hydrogen: 39.67, fossil: 34.34, biofuels: 50.87, other: 0 },
    2050: { electricity: 78.59, hydrogen: 66.56, fossil: 23.73, biofuels: 37.43, other: 0 },
  },

  net_zero_futures_dvl_transform_high_0909: {
    2025: { electricity: 56.24, hydrogen: 0.62, fossil: 140.40, biofuels: 38.78, other: 0 },
    2030: { electricity: 50.94, hydrogen: 0.27, fossil: 108.80, biofuels: 46.65, other: 0 },
    2035: { electricity: 46.00, hydrogen: 3.40, fossil: 83.54,  biofuels: 63.13, other: 0 },
    2040: { electricity: 43.31, hydrogen: 10.38, fossil: 70.38, biofuels: 64.60, other: 0 },
    2045: { electricity: 43.95, hydrogen: 20.44, fossil: 49.51, biofuels: 71.02, other: 0 },
    2050: { electricity: 56.76, hydrogen: 36.76, fossil: 19.42, biofuels: 78.16, other: 0 },
  },

  net_zero_futures_dvl_transform_low_0909: {
    2025: { electricity: 56.24, hydrogen: 0.62, fossil: 140.40, biofuels: 38.78, other: 0 },
    2030: { electricity: 51.16, hydrogen: 0.27, fossil: 110.27, biofuels: 44.98, other: 0 },
    2035: { electricity: 46.32, hydrogen: 3.41, fossil: 84.61,  biofuels: 62.44, other: 0 },
    2040: { electricity: 43.59, hydrogen: 10.24, fossil: 72.26, biofuels: 63.08, other: 0 },
    2045: { electricity: 43.99, hydrogen: 20.22, fossil: 51.49, biofuels: 69.80, other: 0 },
    2050: { electricity: 56.96, hydrogen: 36.42, fossil: 19.14, biofuels: 77.50, other: 0 },
  },
  net_zero_futures_dvl_shift_high_transstshiftec_2001: {
    2025: { electricity: 56.24,    hydrogen: 0.62,    fossil: 140.39, biofuels: 38.79, other: 0 },
    2030: { electricity: 52.74, hydrogen: 2.72,    fossil: 122.11, biofuels: 43.83,  other: 0 },
    2035: { electricity: 49.80, hydrogen: 8.96,  fossil: 91.91,  biofuels: 59.12, other: 0 },
    2040: { electricity: 44.81, hydrogen: 15.58, fossil: 83.28, biofuels: 60.56, other: 0 },
    2045: { electricity: 47.28, hydrogen: 29.61,    fossil: 59.84,  biofuels: 63.83, other: 0 },
    2050: { electricity: 54.95, hydrogen: 50.73, fossil: 22.51,     biofuels: 70.49, other: 0 },
  },
};

export default INDUSTRY;
